module.exports = __webpack_public_path__ + "static/img/1.722734be.jpg";